/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Lazy loading of a component Payments Page
 *
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.15.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PaymentsPage" */ './components/PagePayments'));
